import { CommonModule } from "@angular/common";
import {
  Component,
  Input,
  QueryList,
  Type,
  ViewChildren,
  ViewContainerRef,
} from "@angular/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { AccordionData } from "../../../core/models/accordion-fields";

@Component({
  selector: "app-accordion",
  standalone: true,
  imports: [MatExpansionModule, CommonModule],
  templateUrl: "./accordion.component.html",
  styleUrl: "./accordion.component.scss",
})
export class AccordionComponent {
  @Input() accordionData: AccordionData[] = [];

  @ViewChildren("dynamicContent", { read: ViewContainerRef })
  dynamicContents!: QueryList<ViewContainerRef>;

  ngAfterViewInit() {
    if (this.accordionData?.length > 0) {
      this.loadComponent(0);
    }
  }

  onPanelExpand(index: any) {
    this.loadComponent(index);
  }

  loadComponent<T>(index: number) {
    const viewContainerRef = this.dynamicContents.toArray()[index];
    viewContainerRef.clear();

    const accordion = this.accordionData[index];
    if (accordion && accordion.component) {
      const componentRef = viewContainerRef.createComponent<T>(
        accordion.component as Type<T>
      );

      (componentRef.instance as T & { data?: any }).data = accordion;
    }
  }
}
